import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

const ChemicalBurns = ({ onNext, onBack }) => {
  const [chemicalType, setChemicalType] = useState('');

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-black py-4">
      <div className="w-full max-w-sm mx-auto px-4">
        <div className="flex flex-col min-h-screen bg-zinc-900 rounded-3xl border-2 border-orange-500/30 shadow-2xl overflow-hidden">
          <div className="flex items-center justify-between p-4 border-b-2 border-orange-500/30">
            <Button onClick={onBack} variant="ghost" className="flex items-center gap-2 text-orange-500 text-lg font-bold">
              <ArrowLeft className="w-6 h-6" /> Back
            </Button>
            <h1 className="text-lg font-black text-orange-500">Chemical Burns</h1>
            <div className="w-16" />
          </div>

          <div className="flex-grow overflow-y-auto p-4 bg-black space-y-5">
            <div className="bg-zinc-900 p-5 rounded-2xl border-2 border-orange-500/20">
              <p className="text-lg text-orange-100 leading-relaxed">
                <span className="text-3xl mr-2">💧</span>
                Immediately begin copious irrigation with water for at least 30 minutes. Remove all contaminated clothing. Use PPE.
              </p>
            </div>

            <div>
              <label className="block text-lg font-bold text-orange-400 mb-3">Select Chemical Type</label>
              <select
                value={chemicalType}
                onChange={(e) => setChemicalType(e.target.value)}
                className="w-full bg-zinc-900 border-2 border-orange-500/30 text-lg text-orange-100 py-4 px-4 rounded-xl focus:ring-orange-500 focus:border-orange-500"
              >
                <option value="">Select Chemical Type</option>
                <option value="acid">Acid</option>
                <option value="alkali">Alkali</option>
                <option value="hydrofluoric_acid">Hydrofluoric Acid</option>
                <option value="phenol">Phenol</option>
                <option value="phosphorus">Phosphorus</option>
              </select>
            </div>

            {chemicalType === 'hydrofluoric_acid' && (
              <div className="bg-red-900/40 border-2 border-red-500 text-red-200 p-5 rounded-2xl">
                <p className="font-black text-xl mb-2">⚠️ High Danger: Hydrofluoric Acid</p>
                <p className="text-lg leading-relaxed">Systemic toxicity. Requires immediate specialized treatment with Calcium Gluconate. Cardiac monitoring essential.</p>
              </div>
            )}
          </div>

          <div className="p-4 bg-zinc-900 border-t-2 border-orange-500/30">
            <Button onClick={onNext} className="w-full h-14 bg-orange-500 text-white text-lg font-black rounded-xl hover:bg-orange-600 shadow-xl">
              Return to Mechanism
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChemicalBurns;